import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
const makeRequestDebounced = createDebounce(makeRequest, 200);
const API_URL = import.meta.env.VITE_API_URL;

export async function getChargePaged({
  status = [],
  search = "",
  startDate = "",
  endDate = "",
  startDateAtualizadoEm = "",
  endDateAtualizadoEm = "",
  page = 1,
  itemsPerPage = 10,
  orderBy = "",
  technicalConsultant = "",
  fields = "_id, externalId, dueDate, paymentDate, chargeType, clientType, clientId, amount, status, details, notes, createdAt, updatedAt, contest",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);
  params.append("filters[clientType]", "PARTNER");
  startDate && params.append("filters[startDate]", startDate.toString());
  endDate && params.append("filters[endDate]", endDate.toString());
  startDateAtualizadoEm &&
    params.append(
      "filters[startDateAtualizadoEm]",
      startDateAtualizadoEm.toString()
    );
  endDateAtualizadoEm &&
    params.append(
      "filters[endDateAtualizadoEm]",
      endDateAtualizadoEm.toString()
    );
  technicalConsultant &&
    params.append("filters[technicalConsultant]", technicalConsultant);

  const url = `${API_URL}/charges-paged?${params.toString()}`;
  return (await makeRequestDebounced(url)) as ApiResponseType<unknown>;
}

export const chargesDendDispute = async (
  chargeId: string,
  messageResponse: string
) => {
  const url = `${API_URL}/charges-send-dispute`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      chargeId,
      messageResponse,
    }),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<unknown>
  >;
};
